export default class FreeForAllDoctor {
    static doctors = [
        "Team RTwA",
        "Dok Rawin",
        "drh. perkedatangan"
    ]
}

